import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./index.module.scss";
import arrowOutlinedRight from "@/assets/arrow-outlined-right.svg";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";
import { Url } from "@/helpers/url";

export interface GoToReplacementButtonProps {
  productUrl?: string;
  disabled?: boolean;
  className?: string;
  part?: string;
}

const GoToReplacementButton: React.FC<GoToReplacementButtonProps> = ({
  productUrl,
  disabled,
  className,
  part,
}) => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    if (productUrl) {
      Url.route(productUrl);
    }
  }, [productUrl]);

  return (
    <div className={classNames(styles.root, className)} part={part}>
      <FixButton className={styles.button} variant="primary" size={"large"} disabled={disabled} onClick={handleClick}>
        <Icon className={styles.icon} src={arrowOutlinedRight} height={16} />
        {t("nusdf89g8ihuesrn.go-to-replacement-product", "Go to replacement product")}
      </FixButton>
    </div>
  );
};

export default GoToReplacementButton;

